
			import { isDevServer } from '../remote/src/lib/dev-server';

			/**
			 * Dynamically create <link rel="manifest" /> to enable using Playground with
			 * a Blueprint as an offline progressive web app.
			 *
			 * We don't have a static <link rel="manifest" /> element in the initial HTML
			 * because Safari would just go with it and ignore the dynamic updates made below.
			 * It has no problem with dynamically created manifest element, though.
			 *
			 * If this method ever fails, we'll need to rename index.html to index.php and
			 * ensure the <link rel="manifest" /> element is shipped in the initial HTML.
			 */

			/**
			 * On the local dev server, use the static manifest.json file.
			 * Outside of the local dev server, use the dynamic manifest that
			 * passes the query parameters through to the "start_url" property.
			 */
			let manifestUrl = new URL('manifest.json', window.location.href);

			/**
			 * In production, load a manifest URL that includes the current URL
			 * as the "start_url" parameter.
			 */
			if (!isDevServer(new URL(window.location.href))) {
				const runningAsPWA = window.matchMedia(
					'(display-mode: standalone)'
				).matches;

				/**
				 * If we're running as an installed, offline app, keep referencing the
				 * same manifest.json file every time.
				 */
				const storedManifestUrl = localStorage.getItem('manifestUrl');
				if (runningAsPWA && storedManifestUrl) {
					manifestUrl = new URL(
						storedManifestUrl,
						window.location.href
					);
				} else {
					manifestUrl = new URL(
						'/dynamic-manifest.json.php',
						window.location.href
					);
					manifestUrl.search = window.location.search;

					/**
					 * Remember the manifest URL used for installation, so
					 * standalone launches keep the original start_url.
					 */
					localStorage.setItem('manifestUrl', manifestUrl.toString());
				}
			}
			const newLink = document.createElement('link');
			newLink.rel = 'manifest';
			newLink.href = manifestUrl.toString();
			document.head.appendChild(newLink);
		